import { apiFetch } from './client.js';
import type { PivotRow, SalesGranularity } from './sales.js';

export type ClientSalesTable = 'b2b_l2' | 'rida_l2';

export type ClientPivotRequest = {
  table: ClientSalesTable;
  levels: string[];
  granularity: SalesGranularity;
  dateFrom?: string;
  dateTo?: string;
  filters?: Record<string, string | string[]>;
  limit?: number;
};

export type ClientSalesMeta = {
  hasB2bL2: boolean;
  hasRidaL2: boolean;
  b2bL2LastDate: string | null;
  ridaL2LastDate: string | null;
};

export const clientSalesApi = {
  pivot: (req: ClientPivotRequest) =>
    apiFetch<{ rows: PivotRow[] }>(`/api/client/sales/pivot`, {
      method: 'POST',
      body: JSON.stringify(req),
    }),
  meta: () => apiFetch<ClientSalesMeta>(`/api/client/sales/meta`),
};
